module.exports = __webpack_public_path__ + "img/Picture2.9e8b5623.png";